import { proxy } from 'valtio';

export const documentStore = proxy({
    selectedFolderId: null,
    selectedFolderName: null,
    selectedFolderPath: null,
});
